import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { CompanyData } from '../../../types/company-data';
import { User } from '../../../types/user';
import { CompanyLicenseInformation } from '../../../../license/types/CompanyLicenseInformation';

export abstract class CompanyLicensingTabBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getMyCompanyData(): Promise<CompanyData>;

  public abstract getManagedCompanyById(companyId: string): Promise<CompanyData>;

  public abstract getLoggedUser(): Promise<User>;

  public abstract getCompanyLicenseInformation(editedCompanyId: string): Promise<CompanyLicenseInformation>;
}
